
import React, { useEffect, useState } from 'react'

import { useProgrammation } from '@/Hooks/UseProgrammation';
import { addInternalProfile, addResponsible } from '@/Services/ProgrammationManagerService';

import UserAvatar from '@/Components/UserAvatar/UserAvatar';

import Spinner from '@/Components/SvgImages/Spinner/Spinner';
import Check from '@/Components/SvgImages/Check';

import { useDispatch } from 'react-redux';
import { updateResponsiblesAction } from '@/Redux/Actions/ProgrammationManagerActions';

import './UserOption.scss'

interface Props {
  profile: any
  subTask?: any
}

const ProfileOption = ({ profile, subTask }: Props) => {

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const [ selecting, setSelecting ] = useState(false)
  const [ selected, setSelected ] = useState(false)

  const task = subTask || itemOpened

  const handleSelect = async () => {

    if (selected) {
      return
    }

    setEditingItem(true)
    setSelecting(true)

    const [ error, data ] = await addInternalProfile(task._id, profile._id)

    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        responsibles: [...itemOpened.responsibles, profile]
      })
    } else {

      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.responsibles = [...subTask.responsibles, profile]
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateResponsiblesAction({ task: data.task, parentTask: data.parentTask }))

    setSelecting(false)
  }

  useEffect(() => {

    const profileFound = task.responsibles.find((u: any) => u._id === profile._id)

    setSelected(profileFound)
  }, [itemOpened])

  return (
    <div className="user-option"
      onClick={handleSelect}
    >
      <div className="user-option-avatar">
        <UserAvatar user={profile} size="md" />
      </div>
      <div className="user-option-content">
        <div className='user-names'>
          {profile.name} {profile.surname}
        </div>
        <div style={{ fontSize: '0.75rem', color: '#777' }}>
          Perfil Interno de {profile.responsible.name} {profile.responsible.surname}
        </div>
      </div>
      <div>
        {!selected && selecting && (
          <Spinner
            height={24}
            width={24}
          />
        )}
        {selected && (
          <Check
            height={24}
            width={24}
          />
        )}
      </div>
    </div>
  )
}

export default ProfileOption
